import React, { useState } from "react";
import { Delete, ArrowBigUp } from "lucide-react";

const ROWS = [
  "1234567890".split(""),
  "qwertyuiop".split(""),
  "asdfghjkl".split(""),
  "zxcvbnm".split(""),
];

export const OnScreenKeyboard = ({ value, onChange, startCaps = true, capsAfterSpace = false }) => {
  const [caps, setCaps] = useState(startCaps);

  const press = (k) => {
    onChange((value || "") + (caps ? k.toUpperCase() : k));
    if (caps) setCaps(false); // auto-lower after a capital (name-friendly)
  };

  const key =
    "h-14 md:h-16 flex-1 basis-0 rounded-xl bg-[#18181B] border border-white/10 text-white font-display font-bold text-xl md:text-2xl active:scale-90 active:bg-[#FF007F] active:border-[#FF007F] transition-all duration-75 flex items-center justify-center";

  return (
    <div data-testid="onscreen-keyboard" className="w-full max-w-3xl mx-auto space-y-2 md:space-y-3 select-none">
      {ROWS.map((row, i) => (
        <div key={i} className="flex gap-1.5 md:gap-2.5">
          {i === 3 && (
            <button
              data-testid="kbd-shift"
              onClick={() => setCaps((c) => !c)}
              className={`${key} basis-auto px-4 ${caps ? "!bg-[#00F0FF] !text-black !border-[#00F0FF]" : ""}`}
            ><ArrowBigUp className="w-6 h-6" /></button>
          )}
          {row.map((k) => (
            <button key={k} data-testid={`kbd-${k}`} onClick={() => press(k)} className={key}>
              {caps ? k.toUpperCase() : k}
            </button>
          ))}
          {i === 3 && (
            <button
              data-testid="kbd-backspace"
              onClick={() => onChange((value || "").slice(0, -1))}
              className={`${key} basis-auto px-4`}
            ><Delete className="w-6 h-6" /></button>
          )}
        </div>
      ))}
      <div className="flex gap-1.5 md:gap-2.5">
        <button data-testid="kbd-space" onClick={() => { onChange((value || "") + " "); if (capsAfterSpace) setCaps(true); }} className={`${key} flex-[6]`}>
          SPACE
        </button>
        <button data-testid="kbd-clear" onClick={() => onChange("")} className={`${key} flex-[2] text-base`}>
          CLEAR
        </button>
      </div>
    </div>
  );
};
